import React, { Component } from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'

import { Layout, Container, PageTitle } from 'src/components/Layout'
import List from 'src/components/List'

import Confirmation from 'src/modals/Confirmation/index'
import { Loader } from 'src/components/Loader'
import Disclaimer from 'src/modals/Disclaimer'

import { Text } from '@chakra-ui/react'

import intlMessages from '../translations'

class MailPinkSlip extends Component {
  state = {
    showConfirmation: false,
    showDisclaimer: false,
  }

  componentDidMount() {
    const { loaded, getPinkSlipAddresses } = this.props

    if (!loaded) {
      getPinkSlipAddresses()
    }
  }

  getAddressesList = (addresses = []) => {
    const { intl } = this.props

    if (!addresses.length) {
      return [
        {
          leftIcon: ['far', 'location-pin'],
          type: 'addAddress',
          name: intl.formatMessage(intlMessages.documentPinkSlipOtherAddress),
          url: '/documents/mail-pinkslip/add',
          rightIcon: 'right',
        },
      ]
    }

    return [
      ...addresses.reduce((result, item) => {
        return [
          ...result,
          {
            leftIcon: 'Location',
            name: `${item.address}, ${item.city}, ${item.zip}, ${item.state}, ${item.country}`,
            onClick: () =>
              this.setState({
                showConfirmation: true,
              }),
            rightIcon: 'right',
            type: 'addresses',
            data: item,
          },
        ]
      }, []),
      {
        leftIcon: 'Location',
        type: 'addAddress',
        name: intl.formatMessage(intlMessages.documentPinkSlipOtherAddress),
        url: '/documents/mail-pinkslip/add',
        rightIcon: 'right',
      },
    ]
  }

  handleClick = item => {
    if (item.type !== 'addAddress') {
      const { document } = this.props
      this.props.setPinkSlipAddress({
        address: item.data.address,
        city: item.data.city,
        country: item.data.country,
        state: item.data.state,
        zip: item.data.zip,
        documentType: document.type,
        documentId: document.id,
      })
    }
  }

  handleBack = () => {
    const { history } = this.props
    history.push('/documents/item')
  }

  handleConfirmation = () => {
    this.setState({
      showDisclaimer: true,
    })
  }

  handleCloseDisclaimer = () => {
    this.setState({
      showDisclaimer: false,
    })
  }

  handleSubmitDisclaimer = () => {
    const { sendPinkSlipAddress } = this.props

    sendPinkSlipAddress({
      address: 'addres',
      city: 'city',
      state: 'state',
      zip: 'zip',
      country: 'country',
    })
  }

  handleCloseConfirmation = () => {
    this.setState({
      showConfirmation: false,
    })
  }

  formatAddressObject = item => {
    return `${item.address}, ${item.city}, ${item.zip}, ${item.state}, ${item.country}`
  }

  renderConfirmationContent = address => {
    if (!address) return
    return (
      <Text>
        <FormattedMessage
          id='app.document.pinkSlip.pleaseConfirmBody'
          defaultMessage='Would you like us to mail your pink slip to'
        />
        <br />
        <b> {this.formatAddressObject(address)} </b>
      </Text>
    )
  }

  render() {
    const { addresses, intl, loading, features, submitting } = this.props
    const { showConfirmation, showDisclaimer } = this.state

    const foundedFeature = features.find(f => f.id == 'documents')
    const title =
      foundedFeature && foundedFeature.title
        ? foundedFeature.title
        : intl.formatMessage(intlMessages.documentsHeadline)

    return (
      <Layout>
        <PageTitle
          title={intl.formatMessage(intlMessages.documentPinkSlipHeadline)}
          subtitle={title}
        />

        <Container>
          <Loader display-if={loading} />
          <List
            display-if={!loading}
            items={this.getAddressesList(addresses)}
            onClick={this.handleClick}
          />

          <Confirmation
            visible={showConfirmation}
            onClose={this.handleCloseConfirmation}
            renderContent={this.renderConfirmationContent({
              address: 'addres',
              city: 'city',
              state: 'state',
              zip: 'zip',
              country: 'country',
            })}
            onConfirm={this.handleConfirmation}
          />

          <Disclaimer
            visible={showDisclaimer}
            loading={submitting}
            onClose={this.handleCloseDisclaimer}
            onSubmit={this.handleSubmitDisclaimer}
          />
        </Container>
      </Layout>
    )
  }
}

export default injectIntl(MailPinkSlip)
